import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';
import { FeatureCode, InstituteFeaturesResponse } from './feature.types';

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private featuresRequest$?: Observable<ReadonlySet<FeatureCode>>;

  constructor(private readonly http: HttpClient) {}

  loadFeatures(): Observable<ReadonlySet<FeatureCode>> {
    this.featuresRequest$ ??= this.http
      .get<InstituteFeaturesResponse>(`${environment.apiUrl}features`)
      .pipe(
        map((response) => new Set(response.features)),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    return this.featuresRequest$;
  }

  hasFeature(feature: FeatureCode): Observable<boolean> {
    return this.loadFeatures().pipe(map((features) => features.has(feature)));
  }

  reset(): void {
    this.featuresRequest$ = undefined;
  }
}
